var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAzoresIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 22.0648 3.37438 27.3411 8.34781 30.0547V1.94556C3.37438 4.65918 0 9.93543 0 16.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 23.3925 5.01381 29.6129 11.8261 31.4489V0.55127C5.01381 2.38727 0 8.60765 0 16.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73912 5.56519V8.17387C5.73912 9.47056 6.79025 10.5217 8.08694 10.5217C9.38363 10.5217 10.4347 9.47056 10.4347 8.17387V5.56519H5.73912Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08736 9.13042C7.55992 9.13042 7.13086 8.70136 7.13086 8.17392V6.95654H9.04392V8.17392C9.04392 8.70136 8.6148 9.13042 8.08736 9.13042Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 16.6955H13.2174C13.2174 15.9271 12.5944 15.3042 11.8261 15.3042C11.0577 15.3042 10.4347 15.9271 10.4347 16.6955H6.26081C6.26081 17.4639 6.93012 18.0868 7.69844 18.0868H7.65212C7.65212 18.8553 8.27494 19.4781 9.04344 19.4781C9.04344 20.2466 9.66625 20.8694 10.4347 20.8694H13.2174C13.9857 20.8694 14.6087 20.2466 14.6087 19.4781C15.3771 19.4781 16 18.8553 16 18.0868H15.9537C16.722 18.0868 17.3913 17.4639 17.3913 16.6955Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9631 14.4691L17.5978 15.0539L18.0409 15.5819L17.3719 15.4153L17.0066 15.9999L16.9584 15.3121L16.2894 15.1453L16.9288 14.887L16.8807 14.1992L17.3239 14.7275L17.9631 14.4691Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8316 12.6807L15.6884 13.3551L16.2855 13.6998L15.5997 13.7722L15.4564 14.4464L15.1759 13.8165L14.4902 13.8885L15.0027 13.4272L14.7223 12.7974L15.3193 13.1421L15.8316 12.6807Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 11.7292L13.3136 12.4121L13.9925 12.5317L13.3729 12.834L13.4688 13.5168L12.99 13.0208L12.3702 13.3231L12.6939 12.7142L12.215 12.2184L12.894 12.338L13.2176 11.7292Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 11.7292L10.7587 12.338L11.4376 12.2183L10.9587 12.7144L11.2824 13.3231L10.6628 13.0208L10.1838 13.5167L10.2797 12.834L9.66006 12.5318L10.339 12.4121L10.4349 11.7292Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82098 12.6807L8.33336 13.1421L8.93036 12.7974L8.65011 13.4274L9.1623 13.8886L8.47673 13.8165L8.19617 14.4464L8.05305 13.772L7.3673 13.7L7.9643 13.3552L7.82098 12.6807Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68912 14.4693L6.32856 14.7277L6.7715 14.1995L6.72362 14.8874L7.36281 15.1457L6.69375 15.3123L6.6455 16.0001L6.28044 15.4155L5.61144 15.5822L6.05462 15.0541L5.68912 14.4693Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAzoresIslands);
export default __webpack_public_path__ + "static/media/flag_azores_islands.254338e03f382b505e98be7e860f5305.svg";
export { ForwardRef as ReactComponent };